import React from 'react';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { UserInterfaceRoute } from './types';
import { SIZES } from '../src/styles/theme';

export const SIDEBAR_PIXEL_WIDTH = SIZES.SIDEBAR_WIDTH;

interface SpanProps {
  text: string;
}
const simpleSpan = ({ text }: SpanProps) => {
  return <span>{text}</span>;
};
const simpleIcon = () => {
  return <ContactMailIcon />;
};

export const Routes: Array<UserInterfaceRoute> = [
  {
    key: 'activecase',
    to: '/app/activecase',
    children: simpleSpan({ text: 'Active Case' }),
    icon: simpleIcon(),
  },
  {
    key: 'settings',
    to: '/app/settings',
    children: simpleSpan({ text: 'Settings' }),
    icon: simpleIcon(),
  },
  {
    key: 'landing',
    to: '/app/landing',
    children: simpleSpan({ text: 'Landing' }),
    icon: simpleIcon(),
  },
  {
    key: 'profile',
    to: '/app/profile',
    children: simpleSpan({ text: 'Profile' }),
    icon: simpleIcon(),
  },
];

export const STORAGE_KEY_USER_EXTENSION = 'cv_portal_user_extension';
export const STORAGE_KEY_AGENT_EXTENSION_FROM_API =
  'cv_portal_agent_extension_from_api';
export const STORAGE_CURRENT_CASE_ID = 'cv_portal_current_case_id';
export const STORAGE_PREVIOUS_CASE_ID = 'cv_portal_previous_case_id';
export const CALL_TERMINATED_TIMEOUT = 90000;
export const STORAGE_KEY_CALL911STATUS = 'cv_portal_call911Status';

// USA, Canada
export const GOOGLE_MAP_LIST_OF_COUNTRY_CODES = ['us', 'ca'];
export const LOCATION_LIST_OF_COUNTRY_CODES = [
  'US',
  'CA',
  'CANADA',
  'UNITED STATES',
];
